<template>
  <div class="row justify-content-center">
    <div class="col-sm-12">
      <center><h6>Budget</h6></center>
      <h5 class="info-text">A budget is a plan on how you would spend your money in a month</h5>
    </div>
    
    <div class="col-12 col-sm-10 mt-3">
        <fg-input label="How much is your yearly rent?  (required)"
          type="number"
          name="rent"
          :error="getError('rent')"
          v-validate="modelValidations.rent"
          v-model="model.rent"
        >
        </fg-input>

        <fg-input label="How much do you spend on food monthly? (required)"
          type="number"
          name="food"
          :error="getError('food')"
          v-validate="modelValidations.food"
          v-model="model.food"
        >
        </fg-input>

        <fg-input label="How much do you spend on transportation monthly?  (required)"
          type="number"
          name="transportation"
          :error="getError('transportation')"
          v-validate="modelValidations.transportation"
          v-model="model.transportation"
        >
        </fg-input>

        <fg-input label="How much do you spend on phone airtime recharge monthly?  (required)"
          type="number"
          name="airtime"
          :error="getError('airtime')"
          v-validate="modelValidations.airtime"
          v-model="model.airtime"
        >
        </fg-input>
      </div>
  </div>
</template>
<script>
  import {Select, Option} from 'element-ui'
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option
    },
    data() {
      return {
        model: {
          rent: '',
          food: '',
          transportation: '',
          airtime: ''
        },
        modelValidations: {
          rent: {
            required: true,
          },
          food: {
            required: true,
          },
          transportation: {
            required: true
          },
          airtime: {
            required: true
          }
        }
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model)
          return res
        })
      }
    }

  }
</script>
<style>
</style>
